export default "__VITE_ASSET__CF_5qWLy__"